var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0207 18.3359C19.0207 19.0042 18.7548 19.6459 18.2828 20.1189C17.8098 20.5909 17.1681 20.8568 16.4998 20.8568H5.49984C4.83159 20.8568 4.18992 20.5909 3.71692 20.1189C3.24484 19.6459 2.979 19.0042 2.979 18.3359V3.66927C2.979 3.00102 3.24484 2.35935 3.71692 1.88635C4.18992 1.41427 4.83159 1.14844 5.49984 1.14844H13.3703C13.7957 1.14844 14.2036 1.3171 14.5043 1.61869L18.5504 5.66485C18.852 5.96552 19.0207 6.37344 19.0207 6.79877V18.3359ZM17.6457 18.3359V6.79877C17.6457 6.73827 17.6218 6.6796 17.5788 6.63652L13.5326 2.59035C13.4895 2.54727 13.4308 2.52344 13.3703 2.52344H5.49984C5.1955 2.52344 4.90492 2.64444 4.6895 2.85894C4.475 3.07435 4.354 3.36494 4.354 3.66927V18.3359C4.354 18.6403 4.475 18.9309 4.6895 19.1463C4.90492 19.3608 5.1955 19.4818 5.49984 19.4818H16.4998C16.8042 19.4818 17.0948 19.3608 17.3102 19.1463C17.5247 18.9309 17.6457 18.6403 17.6457 18.3359Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0625 2.29688C13.0625 1.91737 13.3705 1.60938 13.75 1.60938C14.1295 1.60938 14.4375 1.91737 14.4375 2.29688V5.50521C14.4375 5.63171 14.5402 5.73438 14.6667 5.73438H17.875C18.2545 5.73438 18.5625 6.04238 18.5625 6.42188C18.5625 6.80137 18.2545 7.10938 17.875 7.10938H14.6667C13.7803 7.10938 13.0625 6.39162 13.0625 5.50521V2.29688Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33301 10.3125C6.95351 10.3125 6.64551 10.0045 6.64551 9.625C6.64551 9.2455 6.95351 8.9375 7.33301 8.9375H14.6663C15.0458 8.9375 15.3538 9.2455 15.3538 9.625C15.3538 10.0045 15.0458 10.3125 14.6663 10.3125H7.33301Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33325 13.5234C6.95375 13.5234 6.64575 13.2154 6.64575 12.8359C6.64575 12.4564 6.95375 12.1484 7.33325 12.1484H14.6666C15.0461 12.1484 15.3541 12.4564 15.3541 12.8359C15.3541 13.2154 15.0461 13.5234 14.6666 13.5234H7.33325Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33301 16.7344C6.95351 16.7344 6.64551 16.4264 6.64551 16.0469C6.64551 15.6674 6.95351 15.3594 7.33301 15.3594H11.458C11.8375 15.3594 12.1455 15.6674 12.1455 16.0469C12.1455 16.4264 11.8375 16.7344 11.458 16.7344H7.33301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDocument);
export default __webpack_public_path__ + "static/media/chatDocument.f2efc23aec741f61b9021cf769a7f5e9.svg";
export { ForwardRef as ReactComponent };